import React from 'react';
import { StructuredData } from '../..';
import { FACEBOOK_URL_START, MILAN_PHONE } from '../../../utils';

const MILAN_TWITTER = 'https://twitter.com/milanlaser';

// Used inside MedicalOrganization.founder — no worksFor (would be circular)
const FOUNDERS_BASE = [
    {
        '@type': 'Person',
        name: 'Shikhar Saxena',
        honorificSuffix: 'M.D.',
        jobTitle: 'Owner',
        hasCredential: 'Board Certified in Internal Medicine',
    },
    {
        '@type': 'Person',
        name: 'Abe Schumacher',
        honorificSuffix: 'M.D.',
        jobTitle: 'Owner',
        hasCredential: 'Board Certified in Internal Medicine',
    },
];

// Used for standalone Person schemas — includes worksFor for E-E-A-T
const FOUNDERS = FOUNDERS_BASE.map((founder) => ({
    ...founder,
    worksFor: { '@type': 'MedicalOrganization', name: 'Milan Laser Hair Removal' },
}));

export function MetroStructuredData({ currentMetro }) {
    const metroUrl = `${currentMetro.origin}/locations/${currentMetro.metroPath}/`;

    const storeSameAs = currentMetro.stores.map((store) => `${FACEBOOK_URL_START}${store.platforms.facebook}`);

    return (
        <>
            {/* 2a. MedicalOrganization */}
            <StructuredData>
                {{
                    '@context': 'https://schema.org',
                    '@type': 'MedicalOrganization',
                    name: 'Milan Laser Hair Removal',
                    url: `${currentMetro.origin}/`,
                    description:
                        'Milan Laser provides permanent laser hair removal across 390+ locations. Founded in 2012 by two Board Certified physicians.',
                    foundingDate: '2012',
                    founder: FOUNDERS_BASE,
                    sameAs: [...storeSameAs, MILAN_TWITTER],
                }}
            </StructuredData>

            {/* 2b. ItemList — one MedicalBusiness entry per clinic in this metro */}
            <StructuredData>
                {{
                    '@context': 'https://schema.org',
                    '@type': 'ItemList',
                    name: `Milan Laser Hair Removal — ${currentMetro.name} Area Clinics`,
                    url: metroUrl,
                    numberOfItems: currentMetro.stores.length,
                    itemListElement: currentMetro.stores.map((store, index) => ({
                        '@type': 'ListItem',
                        position: index + 1,
                        item: {
                            '@type': 'MedicalBusiness',
                            name: `Milan Laser Hair Removal - ${store.marketingCity}`,
                            url: `${currentMetro.origin}/locations/${currentMetro.metroPath}/${store.pathname}/`,
                            telephone: store.phone === '' ? MILAN_PHONE : store.phone,
                            address: {
                                '@type': 'PostalAddress',
                                streetAddress: store.address,
                                addressLocality: store.addressCity === '' ? store.marketingCity : store.addressCity,
                                addressRegion: store.stateAbbrev,
                                postalCode: store.zipCode,
                            },
                        },
                    })),
                }}
            </StructuredData>

            {/* 2c. BreadcrumbList */}
            <StructuredData>
                {{
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    itemListElement: [
                        { '@type': 'ListItem', position: 1, name: 'Home', item: currentMetro.origin },
                        {
                            '@type': 'ListItem',
                            position: 2,
                            name: 'Locations',
                            item: `${currentMetro.origin}/locations/`,
                        },
                        { '@type': 'ListItem', position: 3, name: currentMetro.name },
                    ],
                }}
            </StructuredData>

            {/* 2d. CollectionPage */}
            <StructuredData>
                {{
                    '@context': 'https://schema.org',
                    '@type': 'CollectionPage',
                    name: `Milan Laser Hair Removal — ${currentMetro.name} Area Locations`,
                    description: `Find all ${currentMetro.stores.length} Milan Laser Hair Removal ${currentMetro.stores.length === 1 ? 'clinic' : 'clinics'} in the ${currentMetro.name} area.`,
                    url: metroUrl,
                    publisher: {
                        '@type': 'MedicalOrganization',
                        name: 'Milan Laser Hair Removal',
                    },
                }}
            </StructuredData>

            {/* 2e. Person — founders (featured in the About Us section of this page) */}
            {FOUNDERS.map((founder, index) => (
                <StructuredData key={founder.name}>
                    {{
                        '@context': 'https://schema.org',
                        ...founder,
                    }}
                </StructuredData>
            ))}
        </>
    );
}
